import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "./style.css";
import "../../../utils/assests/downpayment.png";
import Header from "../../../Common/header";
import axios from "../../../utils/http";
import { VERIFY_IMEI_DOWNPAYMENT } from "../../../utils/urls";
import Loader from "../../../Common/Loader";
import Box from "@mui/material/Box";
import { Button } from "@material-ui/core";

function DownPayment(props: any) {
  const history = useHistory();
  const historyState: any = history.location.state;
  const application_id: number =
    historyState == undefined
      ? history.push("/dashboard")
      : historyState.application_id;
  const imei: number =
    historyState == undefined ? history.push("/dashboard") : historyState.imei;
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const handleProceed = () => {
    const remember = document.getElementById("remember") as HTMLInputElement;
    if (!remember.checked) {
      return setError("Please select the checkbox");
    }
    setLoader(true);
    axios
      .post(VERIFY_IMEI_DOWNPAYMENT, {
        cd_application_id: application_id,
        imei_number: imei,
      })
      .then((res) => {
        setLoader(false);

        if (res.data.results) {
          history.push("/success", { application_id });
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(
          error.response.data.errors?.detail || error.response.data.errors
        );
        setError(
          error.response.data.errors?.detail || error.response.data.errors
        );
        history.push("/sorry", { application_id });
      });
  };

  const handleInputChange = () => {
    setError("");
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <Box className="grayCard">
      <div>
        <Header pageName="DownPayment Collection" />
      </div>

      <div id="downpaymentCard">
        <div style={{ marginTop: "-34px" }}>
          <h4 style={{ fontWeight: 300 }}>Down Payment and Processing Fee</h4>
          <h1 style={{ marginLeft: "32%", marginTop: "-8%" }}>&#8377;1000</h1>
        </div>
      </div>

      <div>
        <p style={{ textAlign: "center" }}>
          Please collect <strong>Down Payment</strong> and{" "}
          <strong>Processing Fee</strong> to proceed with the application
        </p>
      </div>

      <div style={{ textAlign: "center", marginTop: "150px" }}>
        {error ? <h6 className="errorMsg">{error}</h6> : ""}
        <input
          type="checkbox"
          name="remember"
          id="remember"
          onChange={handleInputChange}
        />
        <span style={{ textAlign: "center" }}>
          &nbsp;Yes! I have collected the Amount
        </span>
      </div>

      <Box sx={{ mt: 4, mb: 4 }}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          onClick={handleProceed}
        >
          Proceed
        </Button>
      </Box>

      <div style={{ textAlign: "center" }}>
        <a
          onClick={() => history.push("/product-details", { application_id })}
          style={{ color: "#b40000", fontWeight: 400 }}
        >
          <u>Change this product</u>
        </a>
      </div>
    </Box>
  );
}

export default DownPayment;
